/* istanbul ignore next */
export const reducer1 = () => { };
//# sourceMappingURL=reducer1.js.map